var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"spells"}},[_c('h2',{staticClass:"capitalize"},[_vm._v(_vm._s(_vm.$t('spells')))])])}
var staticRenderFns = []

export { render, staticRenderFns }